/* eslint-disable @next/next/no-img-element */
import { FC, useState } from 'react';
import { useRouter } from 'next/router';
import { Checkbox, Text } from '@mofid-securities/uikit';
import { ETF_TAVAN_ISIN } from '../constants';
import { Icon } from '@/components/atomic/Icon';
import BottomSheet from '@/components/BottomSheet';
import Button, { LinkButton } from '@/components/Button';
import { Divider } from '@/components/Divider';

const LeverageFundWarningBottomSheet: FC = () => {
  const [isApproved, setIsApproved] = useState(false);

  const { push } = useRouter();

  const handleIsApproved = () => {
    setIsApproved((prevState) => !prevState);
  };

  const handleIssuanceClick = () => {
    push(`/invest/etf/buy/${ETF_TAVAN_ISIN}`);
    BottomSheet.close();
  };

  return (
    <div>
      <div className="flex items-center gap-x-1">
        <Icon
          className="text-warning-filled-primary-enabled"
          icon="info_outline"
          size={20}
        />
        <Text
          className="text-gray-filled-primary-enabled"
          size="md"
          weight="demibold"
        >
          شما درحال خرید صندوق اهرمی هستید
        </Text>
      </div>
      <div className="mt-4 flex flex-col gap-y-2">
        <Text className="text-gray-filled-primary-enabled" size="sm">
          واحدهای ممتاز، واحدهای اهرمی صندوق توان هستند که بسیار پرریسک محسوب
          می‌شوند. برای سرمایه گذاری کم ریسک صندوق توان عادی را برای
          سرمایه‌گذاری انتخاب کنید
        </Text>
        <LinkButton
          className="!text-sm"
          href={'/invest/fund/issuance/12033'}
          onClick={BottomSheet.close}
        >
          خرید صندوق توان عادی
        </LinkButton>
        <img
          alt="جشنواره پس‌انداز مفید"
          className="w-full "
          src="https://s3.ir-thr-at1.arvanstorage.com/mofidapp/fund/leverage-tavan-risk.webp"
        />
        <div className="flex items-start">
          <Checkbox
            checked={isApproved}
            classNames={{
              icon: '!h-6 !w-6 !rounded-md',
              iconChecked: '!h-6 !w-6 after:!left-2 after:!top-1 after:!h-3',
            }}
            onChange={handleIsApproved}
          />
          <Text
            className="text-gray-filled-primary-enabled"
            size="sm"
            weight="medium"
          >
            ریسک خرید واحدهای ممتاز صندوق اهرمی توان را می پذیرم.
          </Text>
        </div>
      </div>
      <Divider contrast="medium" includedWidth={40} mb={16} mt={16} />

      <div className="flex gap-x-4">
        <Button variant="link" isFullWidth onClick={BottomSheet.close}>
          انصراف
        </Button>
        <Button
          color="error"
          disabled={!isApproved}
          id="funds_submit_consultant"
          isFullWidth
          onClick={handleIssuanceClick}
        >
          متوجه شدم
        </Button>
      </div>
    </div>
  );
};

export const openLeverageFundWarningBottomSheet = () => {
  return BottomSheet.open({
    children: <LeverageFundWarningBottomSheet />,
  });
};
